module.exports = __webpack_public_path__ + "img/section5Step3.26f4eb7d.png";